var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fimgBox min-w-1400"},[_c('div',{staticClass:"fimgBox1 min-w-1400"},[_c('div',{staticClass:"fimg1Box max-w-1400"},[_c('img',{staticClass:"imgItem1",attrs:{"src":_vm.fimportedImg1,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }